export default __webpack_public_path__ + "static/media/trovoada-chuva.fe1cdc3d.svg";